import { createCRUDHook } from './createCRUDHook';
import {
  VacationDto,
  VacationRequestDto,
  PTOESTAAvailability,
  usedPTOESTAHourDto,
} from 'utils/models';
import {
  CREATE_BULK_ENTITY,
  GET_ALL_VACATION_REQUEST,
  GET_STAFF_PAID_SICK_TIME_BY_DATE_AND_STAFF_ID,
  GET_VACATION_REQUEST_BY_STAFF_ID,
  GET_PTO_ESTA_AVAILABILITY,
  TBL_VACATION,
  GET_USED_PTO_ESTA_BY_STAFFID_FOR_CURRENT_YEAR,
} from './apiEndPoints';

interface VacationCustomOperations {
  getVacationRequestDataByStaffId: (
    staffId: number
  ) => Promise<VacationRequestDto>;
  GetUsedPtoEstaByStaffIdForCurrentYear: (
    staffId: number
  ) => Promise<usedPTOESTAHourDto>;

  getAllVacationRequestData: (
    status: number,
    staffId?: number
  ) => Promise<VacationRequestDto>;

  GetPTOESTAAvailability: (
    staffId: number,
    year?: number
  ) => Promise<PTOESTAAvailability>;

  addBulkEntityVacationData: (param: VacationDto[]) => Promise<boolean>;

  getStaffPaidSickTimeByDateAndStaffId: (
    startDate: string,
    endDate: string,
    staffId: number
  ) => Promise<VacationDto[]>;
}

const { Context, useManager, useConsumer } = createCRUDHook<
  VacationDto,
  VacationDto[],
  VacationCustomOperations
>({
  entityName: 'Vacation',
  endpoint: TBL_VACATION,

  customOperations: (auth) => ({
    getVacationRequestDataByStaffId: async (
      staffId: number
    ): Promise<VacationRequestDto> => {
      try {
        const res = await auth.makeAuthenticatedGet(
          TBL_VACATION +
            GET_VACATION_REQUEST_BY_STAFF_ID +
            `?staffId=${staffId}`
        );
        return Promise.resolve(res.data);
      } catch (error) {
        return Promise.reject(error);
      }
    },
    GetUsedPtoEstaByStaffIdForCurrentYear: async (
      staffId: number
    ): Promise<usedPTOESTAHourDto> => {
      try {
        const res = await auth.makeAuthenticatedGet(
          TBL_VACATION +
            GET_USED_PTO_ESTA_BY_STAFFID_FOR_CURRENT_YEAR +
            `?staffId=${staffId}`
        );
        return Promise.resolve(res.data);
      } catch (error) {
        return Promise.reject(error);
      }
    },

    getAllVacationRequestData: async (
      status: number,
      staffId?: number
    ): Promise<VacationRequestDto> => {
      try {
        const res = await auth.makeAuthenticatedGet(
          TBL_VACATION +
            GET_ALL_VACATION_REQUEST +
            `?status=${status}&staffId=${staffId}`
        );
        return Promise.resolve(res.data);
      } catch (error) {
        return Promise.reject(error);
      }
    },

    GetPTOESTAAvailability: async (
      staffId: number,
      year?: number
    ): Promise<PTOESTAAvailability> => {
      try {
        const res = await auth.makeAuthenticatedGet(
          TBL_VACATION +
            GET_PTO_ESTA_AVAILABILITY +
            `?staffId=${staffId}&year=${year}`
        );
        return Promise.resolve(res.data);
      } catch (error) {
        return Promise.reject(error);
      }
    },

    addBulkEntityVacationData: async (
      param: VacationDto[]
    ): Promise<boolean> => {
      try {
        const res = await auth.makeAuthenticatedPost(
          TBL_VACATION + CREATE_BULK_ENTITY,
          param
        );
        return Promise.resolve(res.data);
      } catch (error) {
        return Promise.reject(error);
      }
    },

    getStaffPaidSickTimeByDateAndStaffId: async (
      startDate: string,
      endDate: string,
      staffId: number
    ): Promise<VacationDto[]> => {
      try {
        const res = await auth.makeAuthenticatedGet(
          TBL_VACATION +
            GET_STAFF_PAID_SICK_TIME_BY_DATE_AND_STAFF_ID +
            `?startDate=${startDate}&endDate=${endDate}&staffId=${staffId}`
        );
        return Promise.resolve(res.data);
      } catch (error) {
        return Promise.reject(error);
      }
    },
  }),
});

export const VacationContext = Context;
export const useVacationManager = useManager;
export const useVacation = useConsumer;
